module.exports = __webpack_public_path__ + "static/media/logo_leonardo.a137204c.png";